import { AppType } from './appSelect';

export const appType = process.env.REACT_APP_APP_TYPE ?? AppType.DEFAULT;

export const isTrackListeningRestricted = JSON.parse(
  process.env.REACT_APP_IS_TRACK_LISTENING_RESTRICTED?.toLowerCase() ?? 'false',
);
